import React from 'react';

import {Pagination} from 'lib/Listings';

import ResultsPageLoader from './ResultsPageLoader';

interface Props {
  children: JSX.Element;
  pagination: Pagination;
  setOffset: (offset: number) => void;
}

export default function CompactResultsPagerWrapper(props: Props): JSX.Element {
  const hasPreviousItems = props.pagination.offset - props.pagination.limit >= 0;
  const hasNextItems = props.pagination.offset + props.pagination.limit < props.pagination.total;
  return (
    <div>
      {hasPreviousItems && (
        <ResultsPageLoader
          isPrevious={true}
          limit={props.pagination.limit}
          offset={props.pagination.offset}
          setOffset={props.setOffset}
        />
      )}
      {props.children}
      {hasNextItems && (
        <ResultsPageLoader
          isPrevious={false}
          limit={props.pagination.limit}
          offset={props.pagination.offset}
          setOffset={props.setOffset}
        />
      )}
    </div>
  );
}
